/**
 * configDigest — a stable, order-independent, non-cryptographic digest of an
 * active constraint set (MathToolImplementation.md §3.4 / §6.1).
 *
 * It is the runtime expression of "no equivocation" (INV-NOEQUIV): every Verdict
 * carries the digest of the config it holds under, so a cached verdict whose
 * digest does not match the current config is treated as `unverified` until
 * re-derived.
 *
 * Properties this guarantees (all checked by the property suite):
 *   - deterministic: same active set ⇒ same digest, on every run (INV-DET);
 *   - order-independent: the digest does not depend on Set insertion order
 *     (the ids are sorted before hashing);
 *   - pure: no time, randomness, locale, or ambient state.
 */
/** FNV-1a 32-bit. Deterministic; no randomness. */
function fnv1a(input) {
    let h = 0x811c9dc5;
    for (let i = 0; i < input.length; i++) {
        h ^= input.charCodeAt(i);
        h = Math.imul(h, 0x01000193);
    }
    return (h >>> 0).toString(16).padStart(8, '0');
}
/** Unit-separator delimiter (U+001F); not expected to occur inside an id. */
const SEP = '\u001f';
export function configDigest(c) {
    // Sorting makes the digest order-independent; constraint ids are plain strings.
    const ids = [...c].slice().sort();
    const joined = ids.join(SEP);
    // Length is folded in to further separate sets that share a hash prefix.
    return `cfg1:${ids.length}:${fnv1a(joined)}`;
}
/** Convenience for callers holding a raw id list (used internally). */
export function digestOfIds(ids) {
    const sorted = ids.slice().sort();
    return `cfg1:${sorted.length}:${fnv1a(sorted.join(SEP))}`;
}
//# sourceMappingURL=digest.js.map